import { Card, Space } from "antd";
import { CheckOutlined, ClockCircleOutlined } from "@ant-design/icons";
import { Folder } from "../../redux/interfaces/folder.types.ts";
import { darkBlue, green } from "../../utils/theme/colors.ts";

interface Props {
  folder: Folder;
}

export const CardStatus: React.FC<Props> = ({ folder }) => {
  const active = folder.is_active ? "Activo" : "Inactivo";
  const status = folder.status;
  const status_map: any = {
    in_progress: "En progreso",
    completed: "Completado",
  };
  const color =
    status === "in_progress"
      ? "font-bold text-blue-400"
      : "font-bold text-green-400";
  const icon =
    status === "in_progress" ? (
      <ClockCircleOutlined style={{ color: darkBlue }} />
    ) : (
      <CheckOutlined style={{ color: green }} />
    );

  return (
    <div className="flex justify-end text-sm font-medium">
      <Card className="flex flex-col">
        <div className="flex">
          <div>Expediente&nbsp;</div>
          <div
            className={
              folder.is_active
                ? "font-bold text-blue-600"
                : "font-bold text-gray-600"
            }
          >
            {active}
          </div>
        </div>

        <Space className="flex justify-center">
          {icon}
          <div className={color}>{status_map[status]}</div>
        </Space>
      </Card>
    </div>
  );
};
